/*
 * Add-to-cart for the drawer cross-sell.
 *
 * Why this exists instead of Dawn's <product-form>: the cross-sell renders
 * inside #CartDrawer-CartItems, which is inside <form id="CartDrawer-Form">.
 * A nested <form> is invalid HTML and the browser drops the inner one, so the
 * button ended up submitting the CART form and navigating away instead of
 * adding. A button plus fetch has no such problem.
 *
 * A custom element, not an inline script, because cart-drawer.js replaces the
 * drawer's innerHTML on every cart change and innerHTML does not execute
 * scripts. Custom elements upgrade on insertion, so this keeps working after
 * each re-render.
 */
if (!customElements.get('orquis-xsell-add')) {
  customElements.define(
    'orquis-xsell-add',
    class OrquisXsellAdd extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        if (!this.button) return;
        this.button.addEventListener('click', this.onClick.bind(this));
      }

      setBusy(busy) {
        this.button.setAttribute('aria-disabled', busy ? 'true' : 'false');
        this.button.classList.toggle('loading', busy);
        this.querySelector('.loading__spinner')?.classList.toggle('hidden', !busy);
      }

      async onClick() {
        if (this.button.getAttribute('aria-disabled') === 'true') return;
        this.setBusy(true);

        const cart = document.querySelector('cart-drawer');
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.body = JSON.stringify({
          items: [{ id: Number(this.dataset.variantId), quantity: 1 }],
          sections: cart ? cart.getSectionsToRender().map((section) => section.id) : [],
          sections_url: window.location.pathname,
        });

        try {
          const response = await fetch(`${routes.cart_add_url}`, config);
          const parsed = await response.json();
          if (parsed.status) throw new Error(parsed.description || parsed.message);

          // renderContents replaces the drawer's markup, discarding this
          // element, so there is no success state to reset.
          if (cart) {
            cart.renderContents(parsed);
          } else {
            window.location.href = routes.cart_url;
          }
        } catch (error) {
          console.error('orquis-xsell-add:', error);
          this.setBusy(false);
        }
      }
    }
  );
}
